export const STATS_REFRESH_DELAY = 100;

export const HEATMAP_GL_CANVAS_SCALE = 0.25;
export const HEATMAP_POINT_SIZE = 100;
export const HEATMAP_MAX_SIZE_MULTIPLIER = 2;
export const HEATMAP_MIN_INTENSITY = 0.4;
export const HEATMAP_MAX_INTENSITY = 2;
export const HEATMAP_INTENSITY_RANGE =
	HEATMAP_MAX_INTENSITY - HEATMAP_MIN_INTENSITY;

export const SCROLLMAP_ROW_HEIGHT = 50;
export const SCROLLMAP_COLORS = [
	'#000000',
	'#00031d',
	'#00052d',
	'#00094f',
	'#000c6a',
	'#000f7f',
	'#0014ac',
	'#0017c6',
	'#001dff',
	'#003dff',
	'#0074ff',
	'#009cff',
	'#00bcff',
	'#00d3ff',
	'#00ebff',
	'#00ffeb',
	'#00ffac',
	'#00ff74',
	'#00ff4d',
	'#2aff00',
	'#62ff00',
	'#91ff00',
	'#b1ff00',
	'#d1ff00',
	'#f8ff00',
	'#ffde00',
	'#ffbe00',
	'#ff9700',
	'#ff7700',
	'#ff5f00',
	'#ff4700',
	'#ff0000',
];
